module.exports = require("core-js-pure/stable/instance/filter");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/filter.js
// module id = 591
// module chunks = 0